import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { BasicButton } from '@shared/ui/basic-button';
import { SminexPlugIcon } from '@shared/assets/icons';
import { styles } from './styles';

export interface IErrorLayout {
  title: string;
  subtitle: string;
}

interface IErrorLayoutProps {
  error: IErrorLayout;
  showBasicButton?: boolean;
  navigateTo?: () => void;
}

export const ErrorLayout: FC<IErrorLayoutProps> = ({ error, showBasicButton, navigateTo }) => {
  return (
    <div translate="no" {...stylex.props(styles.container)}>
      <SminexPlugIcon />
      <p {...stylex.props(styles.title)}>{error.title}</p>
      <p {...stylex.props(styles.subTitle)}>{error.subtitle}</p>
      {showBasicButton ? (
        <BasicButton onClick={navigateTo}>На главную</BasicButton>
      ) : (
        <div style={{ height: '40px' }} />
      )}
    </div>
  );
};
